import { render, staticRenderFns } from "./SubjectAreaPill.vue?vue&type=template&id=879bb038&"
import script from "./SubjectAreaPill.vue?vue&type=script&lang=js&"
export * from "./SubjectAreaPill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports